/** After login, logo/home, "/", and post–deposit/withdraw navigation (frontend user app). */
export const FRONTEND_DEFAULT_MATCH_ROUTE = '/match/4'

/** Featured IPL link in header nav (blinks like live Fav strip). */
export const IPL_2026_ODDS_PATH = '/odds/661707314'

export const CONSTANTS = {
  HIDE_BAL_EXP: 'hide_bal_exp',
  SPORT_NAME: [
    { id: '2', name: 'Tennis' },
    { id: '4', name: 'Cricket' },
    { id: '1', name: 'Soccer' },
  ]
}
export const casinoNavItems = [
  { name: "All Casino", url: "/casino-list/LC/4/35" },
  { name: "Roulette", url: "/casino-list/LC/4/31" },
  { name: "Teenpatti", url: "/casino-list/LC/4/20" },
  { name: "Poker", url: "/casino-list/LC/4/21" },
  { name: "Baccarat", url: "/casino-list/LC/4/22" },
  { name: "Dragon Tiger", url: "/casino-list/LC/4/23" },
  { name: "32 Cards", url: "/casino-list/LC/4/24" },
  { name: "Andar Bahar", url: "/casino-list/LC/4/26" },
  { name: "Lucky 7", url: "/casino-list/LC/4/27" },
  { name: "3 Cards Judgement", url: "/casino-list/LC/4/28" },
  { name: "Casino War", url: "/casino-list/LC/4/29" },
  { name: "Worli", url: "/casino-list/LC/4/30" },
  { name: "Sports", url: "/casino-list/LC/4/34" },
  { name: "Bollywood", url: "/casino-list/LC/4/32" },
  { name: "Lottery", url: "/casino-list/LC/4/33" },
  { name: "Queen", url: "/casino-list/LC/4/40" },
  { name: "Race", url: "/casino-list/LC/4/41" },
  { name: "Others", url: "/casino-list/LC/4/73" },
];